const MAX_32BIT_INT = 0x7fffffff;

// Simple hash algorithm similar to djb2
export function simpleHash(input: string): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = ((hash << 5) + hash + input.charCodeAt(i)) & MAX_32BIT_INT;
  }
  let result = '';
  for (let i = 0; i < 5; i++) {
    result += chars[hash % chars.length];
    hash = Math.floor(hash / chars.length);
  }
  return result;
}
